<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import { useProjectStore } from '@/stores/project'
import { useCalculationStore } from '@/stores/calculation'
import { useCustomRockGradingStore } from '@/stores/customRockGrading'
import { useCostStore } from '@/stores/cost'
import { useProjectUserStore } from '@/stores/projectUser'
import { useAuthorizationStore } from '@/stores/authorization'
import { useDjangoAuthStore } from '@/stores/authDjango'
import { storeToRefs } from 'pinia'
import _ from 'lodash'
import ProjectSideBar from '@/components/project-detail/ProjectSideBar.vue'
import { AppBackground, ProjectHeaderImage } from '@haskoning/vue-component-library'
import type { ProjectUserType } from '@/stores/type/projectUser.type'
import { useMaterialStore } from '@/stores/material'
import router from '@/router'

const route = useRoute()

const projectStore = useProjectStore()
const calculationStore = useCalculationStore()
const materialStore = useMaterialStore()
const customRockGradingStore = useCustomRockGradingStore()
const costStore = useCostStore()

const authStore = useDjangoAuthStore()
const projectUserStore = useProjectUserStore()
const authorizationStore = useAuthorizationStore()

const { currentItem: currentProjectItem } = storeToRefs(projectStore)
const { fetchLoading: calculationFetchLoading } = storeToRefs(calculationStore)
const { items: projectUsers } = storeToRefs(projectUserStore)
const { user: currentUser } = storeToRefs(authStore)

onMounted(async () => {
  calculationFetchLoading.value = true
  if (!currentProjectItem.value || _.isEmpty(currentProjectItem.value)) {
    await projectStore.fetchOptions()
    const projectId = route.params.id as string
    await projectStore.fetchItem(parseInt(projectId))

    if (!currentProjectItem.value || _.isEmpty(currentProjectItem.value)) {
      await router.push({ name: 'not-found' })
    }
  }

  if (currentProjectItem.value) {
    const { id, material, costunitrates } = currentProjectItem.value

    if (id) {
      await projectUserStore.fetchItems({ search: id })
      await authorizationStore.fetchItems()

      const currentProjectUser = projectUsers.value.find(
        (item: ProjectUserType) => item.user === currentUser?.value?.id
      )
      authorizationStore.setCurrentRole([currentProjectUser?.role])

      await calculationStore.fetchOptions()
      await calculationStore.fetchItems({ search: id })
      calculationStore.setSelectedItems([])

      await customRockGradingStore.fetchOptions()
      await customRockGradingStore.fetchItems({ search: id })
      customRockGradingStore.setSelectedItems([])
    }

    if (material) {
      await materialStore.fetchOptions()
      materialStore.setCurrentItem(material)
    }

    if (costunitrates) {
      await costStore.fetchOptions()
      costStore.setCurrentItem(costunitrates)
    }
  }

  calculationFetchLoading.value = false
})

onUnmounted(() => {
  projectStore.resetAll()
  calculationStore.resetAll()
  customRockGradingStore.resetAll()
  costStore.resetAll()
})
</script>
<template>
  <div style="display: flex; flex-direction: column" class="fill-height">
    <ProjectHeaderImage :lazy-src="'/header_lazy.jpg'" :src="'/header.jpeg'" />
    <AppBackground>
      <ProjectSideBar />
      <router-view></router-view>
    </AppBackground>
  </div>
</template>

<style scoped></style>
